import { useStore } from "react-redux";
import "./index.scss";
import { Store } from "@reduxjs/toolkit";
interface props {
  text : string,
  closeModal : any,
  action : any,
  loading? : any
}
const ModalViderBasket = ({ text, closeModal, action , loading } : props) => {
  const store = useStore() as Store;

  return (
    <div className="modal-vider-container">
      <div className="modal-vider-header">
        <i
          className="bx bx-x"
          style={{ fontSize: 26, fontWeight: 700 }}
          onClick={() => closeModal()}
        ></i>
      </div>
      <div className="modal-vider-body">
        <span className="txt-st">{text}</span>
      </div>
      <div className="modal-vider-footer">
        <button className="cancel-btn" onClick={() => closeModal()}>
          Annuler
        </button>
        <button className="save-btn" onClick={action} disabled={loading}>
          {loading ? 'En cours ...' : "Confirmer"} 
        </button>
      </div>
    </div>
  );
};
export default ModalViderBasket;
